import React, { useEffect, useMemo, useState } from "react";
import { Modal, ModalTitle, ModalBody, ModalFooter } from '@vds/modals';
import {Button} from '@vds/buttons';
import { Input } from '@vds/inputs';
import SearchIcon from "@vds/icons/search";
import LeftCaretIcon from "@vds/icons/left-caret";
import PrintIcon from "@vds/icons/print";
import './css/ChannelModal.css';
import { isMobile, isDeviceType } from './utils/generic'

function ChannelModal(props) {
    const IsMobile = isMobile();
    const deviceType = isDeviceType();
    const showCheckAvailability = deviceType ? 'noCheck' : 'showCheck';
    const [totalChannelList, setTotalChannelList] = useState([]);
    const [channelNameOne, setChannelNameOne] = useState([]);
    const [channelNameTwo, setChannelNameTwo] = useState([]);
    const [filter, setFilter] = useState('A-Z_ORDER');
    const [totalChannelListByNo, setTotalChannelListByNo] = useState([]);
    const [channelListNoOne, setChannelListNoOne] = useState([]);
    const [channelListNoTwo, setchannelListNoTwo] = useState([]);
    const [totalChannelListByGenre, setTotalChannelListByGenre] = useState([]);
    const [channelListByGenreOne, setChannelListByGenreOne] = useState([]);
    const [channelListByGenreTwo, setChannelListByGenreTwo] = useState([]);
    const [gainingChannel, setGainingChannel] = useState([]);
    const [losingChannel, setLosingChannel] = useState([]);
    const [wordEnterd, setWordEntered] = useState("");
    const [filteredData, setFilteredData] = useState([]);
    const [filteredDataTwo, setFilteredDataTwo] = useState([]);
    const [totalFilteredData, setTotalFilteredData] = useState([]);
    const [searchedValue, setSearchedValue] = useState(0);
        let firstLetter, genreToShow = '';
    const backButtonHandler = () => {
        props.enableBackButton();
    }
    const getChannelNameNo = (data) => {
        const channelName = data.map((item) => {
            return item.channelname + " $" + item.channelno
        })
        return channelName;
    }
    const getChannelNoName = (data) => {
        const channelNo = data.map((item) => {
            return item.channelno + " $" + item.channelname
        })
        return channelNo;
    }
    const getChannelGenre = (data) => {
        const channelGenre = data.map((item) => {
            return item.genrelist + " $" + item.channelname + " $" + item.channelno
        })
        return channelGenre;
    }
    useEffect(() => {
        if (props.channelList.length > 0) {
            let channelNameListOne, channelNameListTwo = [];
            channelNameListOne = getChannelNameNo(props.channelList[0]);
            setChannelNameOne(channelNameListOne);
            if (props.channelList.length == 2) {
                channelNameListTwo = getChannelNameNo(props.channelList[1]);
                setChannelNameTwo(channelNameListTwo);
            }
            const availableChannelByName = [...channelNameListOne, ...channelNameListTwo];
            const totalChannel = availableChannelByName.filter((value, index) => availableChannelByName.indexOf(value) === index)
            const ChannelSort = totalChannel.sort((a, b) => a.localeCompare(b, undefined, { numeric: true }));
            setTotalChannelList(ChannelSort);
        }
    }, [props.channelList])

    const channelNameToUpperCase = (channelname) => {
        const order = channelname[0].substr(0, 1)
        const text = order.toUpperCase();
        const first = (firstLetter != text ? text : '')
        firstLetter = text;
        return first;
    }
    const A_ZSelected = () => {
        setFilter('A-Z_ORDER');
    }
    const categorySelected = () => {
        let ChannelGenreListOne, ChannelGenreListTwo = [];
        ChannelGenreListOne = getChannelGenre(props.channelList[0]);
        setChannelListByGenreOne(ChannelGenreListOne);
        if (props.channelList.length == 2) {
            ChannelGenreListTwo = getChannelGenre(props.channelList[1]);
            setChannelListByGenreTwo(ChannelGenreListTwo);
        }
        const availableChannelByGenre = [...ChannelGenreListOne, ...ChannelGenreListTwo];
        const totalChannelByGenre = availableChannelByGenre.filter((value, index) => availableChannelByGenre.indexOf(value) === index)
        const sortChannelGenre = totalChannelByGenre.sort((a, b) => a.localeCompare(b, undefined, { numeric: true }));
        setTotalChannelListByGenre(sortChannelGenre);
        setFilter('CATEGORY');
    }
    const channelNoSelected = () => {
        let channelNoListOne, channelNoListTwo = [];
        channelNoListOne = getChannelNoName(props.channelList[0]);
        setChannelListNoOne(channelNoListOne);
        if (props.channelList.length == 2) {
            channelNoListTwo = getChannelNoName(props.channelList[1]);
            setchannelListNoTwo(channelNoListTwo);
        }
        const availableChannelByNo = [...channelNoListOne, ...channelNoListTwo];
        const totalChannelByNo = availableChannelByNo.filter((value, index) => availableChannelByNo.indexOf(value) === index)
        const sortChannelNo = totalChannelByNo.sort((a, b) => a.localeCompare(b, undefined, { numeric: true }))
        //console.log("sortChannelNo", sortChannelNo);
        setTotalChannelListByNo(sortChannelNo);
        setFilter('CHANNEL_NO');
    }
    const displayGenre = (genre) => {
        const Genre = (genreToShow != genre ? genre : '')
        genreToShow = genre;
        return Genre;
    }
    const gaining = (first, second) => {
        const spreaded = [...first, ...second];
        return spreaded.filter(el => {
            return !(first.includes(el));
        })
    };
    const losing = (first, second, gaining) => {
       const combine = [...first, ...second];
       const totalChannel = combine.filter((value, index) => combine.indexOf(value) === index);
       const spreaded = [...totalChannel, ...gaining];
        return spreaded.filter(el => {
            return !(gaining.includes(el));
        })
    };
    const gainLoseSelected = () => {
        let channelByGainLossOne, channelByGainLossTwo, gainingChannelList, LosingChannelList = [];
        channelByGainLossOne = channelNameOne.filter((value, index) => channelNameOne.indexOf(value) === index);
        channelByGainLossTwo = channelNameTwo.filter((value, index) => channelNameTwo.indexOf(value) === index);
        gainingChannelList = gaining(channelByGainLossOne, channelByGainLossTwo);
        LosingChannelList = losing(channelByGainLossOne ,channelByGainLossTwo, gainingChannelList);
        const gainingListSort = gainingChannelList.sort((a, b) => a.localeCompare(b, undefined, { numeric: true }))
        const losingListSort = LosingChannelList.sort((a, b) => a.localeCompare(b, undefined, { numeric: true }))
        setGainingChannel(gainingListSort);
        setLosingChannel(losingListSort);
        setFilter('GAIN_LOSS');
    }
    const displayGL = (data) => {
        const Text = (genreToShow != data ? data : '')
        genreToShow = data;
        return Text;
    }
    const handleFilter = (event) => {
        const searcheWord = event.target.value;
        setWordEntered(searcheWord)
        function containsNumbers(ele) {
            let num = [];
            num = ele.split('$');
            if(num[1].startsWith(searcheWord)){
                return ele;
            }
          }
        const filteredArrOne = !isNaN(searcheWord) ?  channelNameOne.filter((ele, ind) => {
            return containsNumbers(ele);
        }) : 
        channelNameOne.filter((ele, ind) => {
            return ele.toLowerCase().startsWith(searcheWord.toLowerCase());
        })
        const filteredArrTotal = !isNaN(searcheWord) ? totalChannelList.filter((ele, ind) => {
            return containsNumbers(ele);
        }) :
        totalChannelList.filter((ele, ind) => {
            return ele.toLowerCase().startsWith(searcheWord.toLowerCase());
        })
        let filteredArrTwo = [];
        if (props.channelList.length == 2) {
            filteredArrTwo = !isNaN(searcheWord) ? channelNameTwo.filter((ele, ind) => {
                return containsNumbers(ele);
            }) :
            channelNameTwo.filter((ele, ind) => {
                return ele.toLowerCase().startsWith(searcheWord.toLowerCase());
            })
        }
        if (searcheWord === "") {
            setFilteredData([]);
            setFilteredDataTwo([]);
            setTotalFilteredData([]);
            setSearchedValue(0);
        } else {
            if (props.channelList.length === 1) {
                if (filteredArrOne.length !== 0) {
                  setFilteredData(filteredArrOne);
                  setTotalFilteredData(filteredArrTotal);
                  setSearchedValue(0);
                } else {
                  setSearchedValue(1);
                  setFilteredData([]);
                  setTotalFilteredData([]);
                }
              }
              if (props.channelList.length === 2) {
                if (filteredArrOne.length !== 0 || filteredArrTwo.length !== 0) {
                  setFilteredData(filteredArrOne);
                  setFilteredDataTwo(filteredArrTwo);
                  setTotalFilteredData(filteredArrTotal);
                  setSearchedValue(0);
                } else {
                    setSearchedValue(1);
                    setFilteredData([]);
                    setTotalFilteredData([]);
                    setSearchedValue(2);
                    setFilteredDataTwo([]);
                }
              }
        }
        //console.log("filter4", filteredArrTotal)

    }

    //code on clear button click
    const clearInput = () => {
        setFilteredData([]);
        setFilteredDataTwo([]);
        setTotalFilteredData([]);
        setWordEntered("");
        setSearchedValue(0);
    }
    function getChannelListOne(total, channelIn, frm) {
        return (
            <ul className="category-content">
                <div className="viewAll">
                    {total.map((data,index) => {
                        let channelname = [];
                        let sorting = '';
                        let order = '';
                        channelname = data.split(" $", 2);
                        if (frm == "A-Z") {
                            order = channelNameToUpperCase(channelname);
                            sorting = (order == "" ? "emptyStr" : "alpha-text");
                        }
                        return (
                            <li key={index}>{(channelIn.includes(data)) ?
                                <div className="channel-listbygeneral">
                                    {(frm == "A-Z") && <h6 className={sorting}>{order}</h6>}
                                    <p className="channel-list">{data.split(" $", 1)}</p>
                                    <p className="channel-listsecond">{channelname[1]}</p>
                                </div>
                                :
                                <div className="channel-listbygeneral">
                                    {(frm == "A-Z") && <h6 className={sorting}>{order}</h6>}
                                    <p className="channel-list highlighted-content">{data.split(" $", 1)}</p>
                                    <p className="channel-listsecond highlighted-content">{channelname[1]}</p>
                                </div>}
                            </li>
                        )
                    })
                    }
                </div>
            </ul>
        )
    }
    function getChannelListTwo(total, channelIn, frm) {
        return (
            <ul className="category-content">
                <div className="viewAll">
                    {total.map((data, index) => {
                        let channelname = [];
                        let sorting = '';
                        let order = '';
                        channelname = data.split(" $", 2);
                        if (frm == "A-Z") {
                            order = channelNameToUpperCase(channelname);
                            sorting = (order == "" ? "emptyStr" : "alpha-text");
                        }
                        return (
                            <li key={index}>{(channelIn.includes(data)) ?
                                <div className="channel-listbygeneral">
                                    {(frm == "A-Z") && <h6 className={sorting}>{order}</h6>}
                                    <p className="channel-list">{data.split(" $", 1)}</p>
                                    <p className="channel-listsecond">{channelname[1]}</p>
                                </div>
                                :
                                <div className="channel-listbygeneral">
                                    {(frm == "A-Z") && <h6 className={sorting}>{order}</h6>}
                                    <p className="channel-list highlighted-content">{data.split(" $", 1)}</p>
                                    <p className="channel-listsecond highlighted-content">{channelname[1]}</p>
                                </div>}
                            </li>
                        )
                    })
                    }
                </div>
            </ul>
        )
    }
    const handlePrintPDF = () => {
        const mywindow = window.open('', 'PRINT', 'height=600,width=800');
        mywindow.document.write('<html><head><title>Channel Lineup</title>');
        mywindow.document.write('</head><body >');
        mywindow.document.write('<div style={{display: flex}}>')
        if(props.packageSelected.length == 1){
        mywindow.document.write('<h2 style="width:100%;float:left;">' + props.packageSelected[0].packagename + '</h2>');
        }  
       if(props.packageSelected.length == 2){
        mywindow.document.write('<h2 style="width:50%;float:left;">' + props.packageSelected[0].packagename + '</h2>');
              mywindow.document.write('<h2 style="width:50%;float:right;">' + props.packageSelected[1].packagename + '</h2>');
        }
        mywindow.document.write('</div>')
        mywindow.document.write(`<table style='float:left;  width:50%';>`);
        const channels = channelNameOne;
        channels.forEach(channel => {
            let channelname = channel.split(" $", 2);
            mywindow.document.write('<tr><td><span>' + channelname[0] + '</span>');
             mywindow.document.write("<span style='float: right'>" + channelname[1] + '</span>');
            mywindow.document.write('</td></tr>');
        });
        mywindow.document.write('</table>');
    
        if(props.packageSelected.length == 2){
         mywindow.document.write("<table style='float:left;  width:50%';>");
        const channels = channelNameTwo;
        channels.forEach(channel => {
            let channelname = channel.split(" $", 2);
            mywindow.document.write('<tr><td><span>' + channelname[0] + '</span>');
             mywindow.document.write("<span style='float: right'>" + channelname[1] + '</span>');
            mywindow.document.write('</td></tr>');
        });

        mywindow.document.write('</table>');
        }
        mywindow.document.write('</body></html>');

        mywindow.document.close(); // necessary for IE >= 10
        mywindow.focus(); // necessary for IE >= 10*/

        mywindow.print();
        mywindow.close();

        return true;

    }
    const handleModalToggle=(isOpen)=>{
        console.log("close clicked1")
        if(!isOpen){
            console.log("close clicked2");
            props.enableBackButton();
        }
    }
    return (<div className="channelModalContainer">
        {/* <Modal
            surface="light"
            className="viewchannelLine"
            fullScreenDialog={false}
            disableAnimation={false}
            disableOutsideClick={true}
            opened={open}
            disabled={true}
            width="100%"
            onOpenedChange={(isOpen)=>handleModalToggle(isOpen)}
            customScroll={true}
            id="compareChannelContainer"
        > */}
            
                <div className="channelScrollBarstyle">
                    {/* <ModalTitle> */}
                        <div className="headerChannel">
                            <div className="firstHeader" >
                                <div onClick={backButtonHandler} className="backIcon">
                                    <LeftCaretIcon
                                    color="#000000"
                                    size={IsMobile ? "small" : "medium"}
                                    />
                                </div>
                                <a className="backBtn" onClick={backButtonHandler}>Back</a>
                                <span className="lfaRegion">{props.ifa}</span>
                                <a className="print-btn" onClick={handlePrintPDF}> Print </a>
                                <div className="print-icon" onClick={handlePrintPDF}>
                                    <PrintIcon
                                    color="gray"
                                    size="large"
                                /></div>
                            </div>
                            <div className="secondHeader">
                                {props.packageSelected.map((item, index) => {
                                    return (<div key={index} className={(props.channelList.length) == 2 ? "secondHeaderContentview" :"secondHeaderContent"}>
                                        <div>
                                        <p className="package-name">{item.packagename.replace('&amp;','&')}</p>
                                        <p className="channel-text">{item.totalchannelcount}+ channels ({item.hdchannelcount}in HD)</p>
                                        </div>
                                        <div className={(props.channelList.length) == 2 ? `${showCheckAvailability} checkContainer` :`${showCheckAvailability} checkBtn`}>
                                            <Button
                                                size="small"
                                                disabled={false}
                                               className="checkButton"
                                                use="primary"
                                                href="https://www.verizon.com/inhome/checkavailability?ordering=Y">
                                                Check Availability
                                            </Button>

                                        </div>
                                    </div>)
                                })
                                }
                                
                            </div>

                            <div className="channel-comp-inp">
                                {/* <input type="text" className="text-empty" placeholder="      Search for a channel from the list" value={wordEnterd} onChange={(event) => handleFilter(event)}></input> */}
                                <Input type="text" 
                                    label=" Search for a channel from the list"                                                       
                                    required={false}
                                    error={false}
                                    className="searchChannelField"
                                    value={wordEnterd} onChange={(event) => handleFilter(event)}
                                    data-testid="Search for a channel from the list"></Input>
                                {
                                    wordEnterd.length === 0 &&
                                        <span className="search-icon" aria-hidden="true">
                                        <SearchIcon
                                        color="#000000"
                                        size="large"
                                        />  </span>
                                }
                                      { 
                                        wordEnterd.length > 0 &&
                                       <span className="clear-input" tabindex="0" onClick={clearInput} aria-label="clear search" role="button">Clear</span>
                                }
                                {props.channelList.length == 1 && filteredData.length !== 0 && (
                                    <div className={props.channelList.length > 1 ? 'channelModalContent channel-container' : 'channelModalContent channel-onecontainer'}>
                                        {getChannelListOne(totalFilteredData, filteredData, 'search')}
                                    </div>
                                )}
                                {props.channelList.length == 2 && (filteredData.length !== 0 || filteredDataTwo.length !== 0) && (
                                    <div className={props.channelList.length > 1 ? 'channelModalContent channel-container' : 'channelModalContent channel-onecontainer'}>
                                        {getChannelListOne(totalFilteredData, filteredData, 'search')}
                                        {getChannelListTwo(totalFilteredData, filteredDataTwo, 'search')}
                                    </div>
                                )}
                                {searchedValue > 0 &&
                                <div className="channel-unavailable">
                                        <div className="channel-compare">
                                            <p>
                                            Channel not available in this package
                                            </p>
                                        </div>
                                {searchedValue > 1 &&
                                        <div className="channel-compare">
                                            <p>
                                            Channel not available in this package
                                            </p>
                                        </div>
                                }
                                </div>
                                }
                            </div>
                        </div>
                    {/* </ModalTitle> */}
                    {/* <ModalBody> */}
                        {wordEnterd == '' &&
                            <div className="channelModalContent">
                                <p className="viewContent">View by:
                                    <a tabindex="1" className={`category-select ${filter == 'A-Z_ORDER' ?  'activeFilter' : ''}`}  onClick={A_ZSelected}> A-Z</a>/
                                    <a tabindex="2" className={`category-select ${filter == 'CATEGORY' ?  'activeFilter' : ''}`} onClick={categorySelected}> Category</a>/
                                    <a tabindex="3" className={`category-select ${filter == 'CHANNEL_NO' ?  'activeFilter' : ''}`}  onClick={channelNoSelected}> Channel#</a>
                                    {props.channelList.length == 2 &&
                                        <a tabindex="4" className={`category-select ${filter == 'GAIN_LOSS' ?  'activeFilter' : ''}`}  onClick={gainLoseSelected}>/ Gain & Lose</a>}
                                </p>
                                <div className={props.channelList.length > 1 ? "channel-container" : "channel-onecontainer"}>
                                    {
                                    (filter == "A-Z_ORDER") &&
                                        getChannelListOne(totalChannelList, channelNameOne, "A-Z")
                                    }
                                    {((filter == "A-Z_ORDER") && ((props.channelList.length) == 2)) &&
                                        getChannelListTwo(totalChannelList, channelNameTwo, "A-Z")
                                    }
                                    {(filter == "CATEGORY") &&
                                        <ul className="category-content">
                                            <div className={props.channelList.length > 1 ? "compare" : "viewAll"}>
                                                {totalChannelListByGenre.map((data, index) => {
                                                    let channelname = [];
                                                    channelname = data.split(" $", 3);
                                                    let genre = displayGenre(channelname[0]);
                                                    const showGenre = (genre == "" ? "emptyStr" : "genre-text");
                                                    return (
                                                        <li key={index}>{(channelListByGenreOne.includes(data)) ?
                                                            <div className="channel-listbygeneral">
                                                                <h6 className={showGenre}>{genre}</h6>
                                                                <p className="channel-list">{channelname[1]}</p>
                                                                <p className="channel-listsecond">{channelname[2]}</p>
                                                            </div>
                                                            :
                                                            <div className="channel-listbygeneral">
                                                                <h6 className={showGenre}>{genre}</h6>
                                                                <p className="channel-list highlighted-content">{channelname[1]}</p>
                                                                <p className="channel-listsecond highlighted-content">{channelname[2]}</p>
                                                            </div>}
                                                        </li>
                                                    )
                                                })
                                                }
                                            </div>
                                            {(props.channelList.length) == 2 &&
                                                <div className="channel-compare">
                                                    {totalChannelListByGenre.map((data, index) => {
                                                        let channelname = [];
                                                        channelname = data.split(" $", 3);
                                                        let genre = displayGenre(channelname[0]);
                                                        const showGenre = (genre == "" ? "emptyStr" : "genre-text");
                                                        return (
                                                            <li key={index}>{(channelListByGenreTwo.includes(data)) ?
                                                                <div className="channel-listbygeneral">
                                                                    <h6 className={showGenre}>{genre}</h6>
                                                                    <p  className="channel-list">{channelname[1]}</p>
                                                                    <p className="channel-listsecond">{channelname[2]}</p>
                                                                </div>
                                                                :
                                                                <div className="channel-listbygeneral">
                                                                    <h6 className={showGenre}>{genre}</h6>
                                                                    <p className="channel-list highlighted-content">{channelname[1]}</p>
                                                                    <p className="channel-listsecond highlighted-content">{channelname[2]}</p>
                                                                </div>}
                                                            </li>
                                                        )
                                                    })
                                                    }
                                                </div>
                                            }
                                        </ul>
                                    }
                                    {(filter == "CHANNEL_NO") &&
                                        <ul className="channel_filter">
                                            <div className={(props.channelList.length == 2) ? "compare" : "viewAll"}>
                                                {totalChannelListByNo.map((data, index) => {
                                                    let channelname = [];
                                                    channelname = data.split(" $", 2);
                                                    return (
                                                        <li key={index}>{(channelListNoOne.includes(data)) ?
                                                            <div className="channel-listbygeneral">
                                                                <p className="channel-list">{channelname[1]}</p>
                                                                <p className="channel-listsecond">{data.split(" $", 1)}</p>
                                                            </div>
                                                            :
                                                            <div className="channel-listbygeneral">
                                                                <p className="channel-list highlighted-content">{channelname[1]}</p>
                                                                <p className="channel-listsecond highlighted-content">{data.split(" $", 1)}</p>
                                                            </div>}
                                                        </li>
                                                    )
                                                })
                                                }
                                            </div>
                                            {(props.channelList.length) == 2 &&
                                                <div className="channel-compare">
                                                    {totalChannelListByNo.map((data, index) => {
                                                        let channelname = [];
                                                        channelname = data.split(" $", 2);
                                                        return (
                                                            <li key={index}>{(channelListNoTwo.includes(data)) ?
                                                                <div className="channel-listbygeneral">
                                                                    <p className="channel-list">{channelname[1]}</p>
                                                                    <p  className="channel-listsecond">{data.split(" $", 1)}</p>
                                                                </div>
                                                                :
                                                                <div className="channel-listbygeneral">
                                                                    <p className="channel-list highlighted-content">{channelname[1]}</p>
                                                                    <p className="channel-listsecond highlighted-content">{data.split(" $", 1)}</p>
                                                                </div>}
                                                            </li>
                                                        )
                                                    })
                                                    }
                                                </div>
                                            }
                                        </ul>
                                    }
                                    {(filter == "GAIN_LOSS") &&
                                        <ul className="channel_filter">
                                            <div className="channel-compare"></div>
                                            <div className="channel-compare">
                                                {gainingChannel.map((data, index) => {
                                                    let channelname = [];
                                                    channelname = data.split(" $", 2);
                                                    let genre = displayGL("Getting");
                                                    const showText = (genre == "" ? "emptyTxt" : "genre-text");
                                                    return (
                                                        <li key={index}>
                                                            <div className="channel-listbygeneral">
                                                                <h6 className={showText}>Getting</h6>
                                                                <p className="channel-list">{channelname[0]}</p>
                                                                <p className="channel-listsecond">{channelname[1]}</p>
                                                            </div>
                                                        </li>
                                                    )
                                                })
                                                }
                                                {losingChannel.map((data, index) => {
                                                    let channelname = [];
                                                    channelname = data.split(" $", 2);
                                                    let genre = displayGL("Losing");
                                                    const showText = (genre == "" ? "emptyTxt" : "genre-text");
                                                    return (
                                                        <li key={index}>
                                                            <div className="channel-listbygeneral">
                                                                <h6 className={showText}>Losing</h6>
                                                                <p className="channel-list highlighted-content">{channelname[0]}</p>
                                                                <p className="channel-listsecond highlighted-content">{channelname[1]}</p>
                                                            </div>
                                                        </li>
                                                    )
                                                })
                                                }
                                            </div>
                                        </ul>
                                    }
                                </div>
                            </div>
                        }
                    {/* </ModalBody> */}
                </div>
            
        {/* </Modal> */}
    </div>)
}
export default React.memo(ChannelModal);